var path = '/app/pages/product-group/product-group.html';
var html = "<div class=container style=min-height:440px> <div class=\"row pt-4\"> <div class=col> <button class=\"btn btn-light mr-3\" ui-sref=product-groups> <i class=\"fa fa-long-arrow-left mr-3 text-muted\" aria-hidden=true></i> <span class=text-muted>Product Groups</span> </button> </div> </div> <ui-view></ui-view> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/product-group/product-group.html
// module id = 1191
// module chunks = 0